<div class="section-container">
  <mat-accordion>
    <mat-expansion-panel class="mat-elevation-z0" hideToggle (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
      <mat-expansion-panel-header>
        <mat-panel-title> 
          <div class="header">
            <span class="title">
              <mat-icon class="arrow-icon">
                {{ panelOpenState() ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}
              </mat-icon>
              <span class="name">{{ getTitle() }}</span>
              <span class="notification" *ngIf="!showLoader ;else loading">
              </span>
            </span>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="vehicle-card-list" *ngIf="!showLoader">
        <ng-container *ngIf="!isMyVehicle">
          <app-sales-card *ngFor="let vehicle of (salesOrServiceAppointmentVehicles$ | async)"
            class="sales-card-container" [vehicle]="vehicle" [allInventoryVehicles]="allInventoryVehicles" (appointmentCancel)="onSalesAppointmentCancel(vehicle)">
          </app-sales-card>
        </ng-container>
        
        <ng-container *ngIf="isMyVehicle">
          <app-service-card
            *ngFor="let vehicle of (userVehicles$ | async)"
            class="service-card-container"
            [vehicle]="vehicle"
            [isOwnedVehicle]=true
            (appointmentCancel)="onServiceAppointmentCancel(vehicle,$event)"
          ></app-service-card>
        </ng-container>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
 
</div>

<app-splitter class='app-splitter' *ngIf="!isThisLastSection" [config]="'horizontal 100% 0 1rem'"></app-splitter>
<ng-template #loading>
  <app-loading class="dashboard-loader"
               loadingSymbol="dots"
               text={{getLoadingTxt()}}
               color="var(--dashboard-primary-color)"
               size="1">
  </app-loading>
</ng-template>
